<template>
  <div class="text-center">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="idAccion == 1"
          color="success" 
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>
            mdi-plus
          </v-icon>
          Agregar Correo
        </v-btn>
      </template>
      <span>Agregar Correo</span>
    </v-tooltip>

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="idAccion == 2"
          icon 
          color="info" 
          class="px-0"
          v-bind="attrs"
          v-on="on"
          @click.stop="dialog = true"
        >
          <v-icon>
            mdi-pencil
          </v-icon>
        </v-btn>
      </template>
      <span>Editar Correo</span>
    </v-tooltip>

    <v-dialog
      :name="'dialog_form_servicio_' + idServidorCorreo"
      :key="'dialog_form_servicio_' + idServidorCorreo"
      v-model="dialog"
      fullscreen
      hide-overlay 
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary" name="toolbar_dialog_form_servicio">
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <v-icon color="white">{{ idAccion == 1 ? 'mdi-plus' : 'mdi-pencil' }}</v-icon>
            {{ idAccion == 1 ? 'Agregar Correo' : 'Editar Correo' }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="dialog = false">Cerrar</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-form 
            class="mt-5 my-5"
            ref="form" 
            v-model="valid" 
            :lazy-validation="lazy"
          >
            <v-row>
              <v-col cols="12" md="12" class="px-8">
                <v-card
                  color="#A0935F"
                  dark
                  class="mb-4"
                >
                  <v-card-title class="headline">
                    <v-icon class="mr-2">mdi-information</v-icon> 
                    Información de la Cuenta
                  </v-card-title>
                </v-card>
              <v-row>
               
              </v-row>
                <v-row>
                  <v-col cols="6">
                    <v-text-field
                      v-model="nombreMuestra"
                      :loading="loading"
                      label="Nombre que se muestra *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      dense
                      required
                    ></v-text-field>  
                    <v-text-field
                      v-model="nombreUsuario"
                      :loading="loading"
                      label="Nombre de Usuario *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      dense
                      required
                    ></v-text-field>  
                  
                    <v-text-field
                      v-model="servidorSmtp"
                      :loading="loading"
                      label="Servidor SMTP *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      dense
                      required
                    ></v-text-field>  
                   <v-text-field
                      v-model="correoResponde"
                      :loading="loading"
                      label="Responder a *"
                      :rules="mailRules"
                      outlined
                      dense
                      required
                    ></v-text-field>
                   <v-text-field
                      v-model="puerto"
                      :loading="loading"
                      label="Puerto *"
                     type="number"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                      outlined
                      dense
                      required
                    ></v-text-field>
                  </v-col>
                  <v-row>
                    
                   <v-col cols="11"> 
                    <v-text-field
                      v-model="contrasenaUno"
                       :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show1 ? 'text' : 'password'"
                      :loading="loading"
                      label="Contraseña *"
                      :rules="[(v) => !!v || 'Campo obligatorio']"
                       @click:append="show1 = !show1"
                      outlined
                      dense
                      counter
                      class="input-group--focused"
                      required
                    ></v-text-field>  
                  <v-text-field
                      v-model="contrasenaDos"
                      :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                      :type="show2 ? 'text' : 'password'"
                      :rules="confirmPasswordRules"
                      label="Confirmar contraseña*"
                      @click:append="show2 = !show2"
                      outlined
                       counter
                      dense
                      required
                    ></v-text-field>  
                

                    
                  </v-col>
                  </v-row>
                </v-row>
                </v-col>      
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <small>* Campo obligatorio</small>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="text-center">
                <v-btn
                  large
                  color="success"
                  :disabled="!valid"
                  :loading="loadingSave"
                  @click="guardar"
                >
                <v-icon class="mr-2">mdi-floppy</v-icon>
                  guardar correo
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar
      :name="'snackbar_dialog_form_encuesta_' + idServidorCorreo"
      :key="'snackbar_dialog_form_encuesta_' + idServidorCorreo"
      v-model="snackbar"
      :bottom="true"
      :multi-line="true"
      :color="snackbarColor"
    >
      {{ snackbarTexto }}
      <v-btn dark text @click="snackbar = false">
        Cerrar
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import moment from 'moment'
  import { format, parseISO } from 'date-fns'
import { postServidorCorreo, putServidorCorreo } from "@/api";

export default {
  name: "DialogFormCorreo",
 
  components: {
  
    
  },
 
  props: {
    idAccion: {
      type: Number,
      required: true
    },
    objServidorCorreo: {
      type: Object,
      default: function () {
        return {
      idServidorCorreo: 0,
      nombreMuestra: '',
      nombreUsuario: null,
      servidorSmtp: null,
      correoResponde: null,
      puerto:null,
      contrasenaUno: null,
      contrasenaDos:null,     
      
      


        }
      }
    },
    fnOnSave: {
      type: Function,
      default: () => {}
    }
  },
  data() {
     
    return {
      dialog: false,
      loading: false,
      loadingSave: false,
      valid: false,
      lazy: false,
      flagInitForm: 1,
      idAccionForm: 1,
       idServidorCorreo: 0,
      nombreMuestra: null,
      nombreUsuario: null,
      servidorSmtp: null,
      correoResponde: null,
      puerto:null,
      contrasenaUno: null,
      contrasenaDos:null, 
      snackbar: false,
      snackbarTexto: "",
      snackbarColor: "",
      banLimpiarDatos: 0,
      show1: false,
       show2: false,
        mailRules: this.createMailRules(),
        
 
    };
  },
  
  computed: {
    confirmPasswordRules() {
    const rules = [(this.contrasenaUno === this.contrasenaDos) || "Las contraseñas deben coincidir."];
    return rules;
   },
    
  },
  watch:{
    dialog: {
      handler (newValue, oldValue) {
        if(this.$refs.form != undefined && newValue == true){
          this.$refs.form.resetValidation();
        }
        if(newValue == true){
      this.idServidorCorreo=this.objServidorCorreo.idServidorCorreo;
      this.nombreMuestra=this.objServidorCorreo.nombreMuestra;
      this.nombreUsuario=this.objServidorCorreo.nombreUsuario;
      this.servidorSmtp=this.objServidorCorreo.servidorSmtp;
      this.correoResponde=this.objServidorCorreo.correoResponde;
      this.puerto=this.objServidorCorreo.puerto;
      this.contrasenaUno=this.objServidorCorreo.contrasenaUno;
      this.contrasenaDos=this.objServidorCorreo.contrasenaDos;
        }
        else{
      this.idServidorCorreo= 0;
      this.nombreMuestra=null;
      this.nombreUsuario=null;
      this.servidorSmtp=null;
      this.correoResponde=null;
      this.puerto=null;
      this.contrasenaUno=null;
      this.contrasenaDos=null;
       }
			},
    }
  },
  beforeMount(){
  },
  mounted() {
  },
  methods: {
    createMailRules() {
      return [
        (v) => !!v || "Este campo es requerido.",
        (v) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || "Por favor ingrese un correo electrónico válido";
        },
      ];
    },
    async guardar(){
      var self = this;

      if (self.$refs.form.validate()) {

        self.loadingSave = true;
        self.snackbar = false;
        self.snackbarTexto = "";
        self.snackbarColor = "";
            
        try {
          let response;
          var obj = {
      idServidorCorreo: this.idServidorCorreo,
      nombreMuestra:this.nombreMuestra,
      nombreUsuario:this.nombreUsuario,
      servidorSmtp: this.servidorSmtp,
      correoResponde:this.correoResponde,
      puerto: this.puerto,
      contrasenaUno: this.contrasenaUno,
      contrasenaDos:this.contrasenaDos
      }

          if(obj.idServidorCorreo == 0){
            response = await postServidorCorreo(obj);
          }
          else{
            response = await putServidorCorreo(obj);
          }

          if (response.status === 200) {
            if (response.data.flag === true) {
              if (response.data.message === "Guardado correcto") {
                self.snackbarTexto = "Servidor de correo guardado con éxito";
                self.snackbarColor = "success";
                self.snackbar = true;

                self.fnOnSave();

                self.dialog = false;
              }
            } else {
              self.snackbarTexto = "DialogFormServidorCorreo: " + response.data.message;
              self.snackbarColor = "error";
              self.snackbar = true;
            }
          } else {
            self.snackbarTexto = "DialogFormServidorCorreo: Error de red";
            self.snackbarColor = "error";
            self.snackbar = true;
          }
          self.loadingSave = false;
        } catch (e) {
          self.loadingSave = false;
          self.snackbarTexto = "DialogFormServidorCorreo: " + e;
          self.snackbarColor = "error";
          self.snackbar = true;
        }
      }
    },
  },  
};
</script>